/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from 'three'
import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { GLTF } from 'three/examples/jsm/loaders/GLTFLoader'
import { useFrame } from '@react-three/fiber'

type GLTFResult = GLTF & {
  nodes: {
    Elephant: THREE.Mesh
  }
  materials: {
    ['Material.001']: THREE.MeshStandardMaterial
  }
}

const modelFileUrl = 'haathi.glb'
useGLTF.preload(modelFileUrl)

export const Model = (props: any) => {
  const group = useRef()
  const { nodes, materials } = useGLTF(modelFileUrl) as unknown as GLTFResult

  useFrame((state, delta) => {
    const [annotations, dXdt] = props.getAnnotations()

    if(Math.abs(dXdt) > 10 && Math.abs(dXdt)<100){
      group.current.rotation.y += 1e-3*dXdt*2*Math.PI
    }
  })
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        name="Elephant"
        castShadow
        receiveShadow
        geometry={nodes.Elephant.geometry}
        material={materials['Material.001']}
        position={[2.4934907, -0.23355922, 3.04290962]}
        rotation={[0.20654576, -0.0039926, -0.10745444]}
      />
    </group>
  )
}

